module.exports = "/_next/static/images/7-4ba056e75ed50baf5b42eee004c9bb02.png";